export default function useLogger() {
  const console = (function (oldCons) {
    return {
      log: function (...args) {
        !process.env.IS_PRODUCTION && oldCons.log(...args);
      },
      info: function (text) {
        !process.env.IS_PRODUCTION && oldCons.info(text);
      },
      warn: function (text) {
        !process.env.IS_PRODUCTION && oldCons.warn(text);
      },
      error: function (...args) {
        !process.env.IS_PRODUCTION && oldCons.error(...args);
        if (window?.newrelic) {
          var err = new Error(JSON.stringify(args));
          window.newrelic.noticeError(err);
        }
      }
    };
  })(window.console);

  window.console = console;
}
